import { c as _c } from "react/compiler-runtime";
import { ListItemCardMobile } from "@components/common/mobile/list-item-card-mobile";
import { ProjectCardDate } from "@components/common/project-card/project-card-date";
import { ProjectLocationEditor } from "@components/project-location-editor/project-location-editor";
import { PROJECTS_SORT_BY_MAP } from "@components/projects/projects-sort-constants";
import { LocationPinIcon, LocationNotDefinedIcon, NO_TRANSLATE_CLASS, Tooltip } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
import { defaultProjectThumbnail, getProjectAccessAndSize, getProjectLocation, shouldHideOpenProject, trackGoToProjectLocation, trackOpenProjectLocationEditor } from "@utils/project-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { ProjectOpenButton } from "@components/project/project-open-button";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useState } from "react";
/**
 * @returns The map view secondary row content: a clickable location icon followed by
 * the project address or coordinates. Clicking a project with a location navigates the
 * map to its position; clicking "No location" opens the edit location dialog.
 */
function ProjectLocationText(t0) {
  const $ = _c(27);
  const {
    project,
    goTo
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const [isLocationEditorOpen, setIsLocationEditorOpen] = useState(false);
  let t1;
  if ($[0] !== project) {
    t1 = getProjectLocation(project);
    $[0] = project;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    location,
    tooltip
  } = t1;
  const LocationIcon = location ? LocationPinIcon : LocationNotDefinedIcon;
  let t2;
  if ($[2] !== goTo || $[3] !== project.position || $[4] !== trackEvent) {
    t2 = function handleClick(event) {
      event.stopPropagation();
      event.preventDefault();
      if (project.position && goTo) {
        trackGoToProjectLocation({
          trackEvent,
          source: "project card location button"
        });
        goTo(project.position);
        return;
      }
      trackOpenProjectLocationEditor({
        trackEvent,
        source: "project card location button"
      });
      setIsLocationEditorOpen(true);
    };
    $[2] = goTo;
    $[3] = project.position;
    $[4] = trackEvent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleClick = t2;
  let t3;
  if ($[6] !== tooltip) {
    t3 = tooltip ? <Box component="var" className={NO_TRANSLATE_CLASS}>{tooltip}</Box> : null;
    $[6] = tooltip;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const tooltipTitle = t3;
  const t4 = tooltipTitle ?? "";
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      minWidth: 0,
      maxWidth: "100%",
      textTransform: "none",
      cursor: "pointer",
      position: "relative",
      zIndex: 1,
      "&:hover": {
        textDecoration: "underline"
      }
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "1rem",
      height: "1rem",
      flexShrink: 0,
      pointerEvents: "none"
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== LocationIcon) {
    t7 = <LocationIcon sx={t6} />;
    $[10] = LocationIcon;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== location) {
    t8 = location ? <Box component="var" sx={{
      ...withEllipsis,
      minWidth: 0
    }}>{location}</Box> : <span>No location</span>;
    $[12] = location;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleClick || $[15] !== t7 || $[16] !== t8) {
    t9 = <Box component="span" onClick={handleClick} sx={t5}>{t7}{t8}</Box>;
    $[14] = handleClick;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t9) {
    t10 = <Tooltip component="div" title={t4}>{t9}</Tooltip>;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isLocationEditorOpen || $[22] !== project) {
    t11 = isLocationEditorOpen && <Box onClick={_temp}><ProjectLocationEditor project={project} onClose={() => setIsLocationEditorOpen(false)} /></Box>;
    $[21] = isLocationEditorOpen;
    $[22] = project;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}

/**
 * @returns A card with information of the passed project for the project list in mobile view.
 */
function _temp(event_0) {
  return event_0.stopPropagation();
}
export function ProjectListItemCardMobile(t0) {
  const $ = _c(31);
  const {
    project,
    sortBy,
    contextType,
    href,
    onCardClick,
    menuItems,
    variant,
    isSelected,
    goTo
  } = t0;
  const {
    isScreenXs
  } = useMediaQueryList();
  const sortField = PROJECTS_SORT_BY_MAP[sortBy].field;
  const shouldShowLocation = contextType === "project-map-view" && sortField !== "size";
  let t1;
  if ($[0] !== goTo || $[1] !== project || $[2] !== shouldShowLocation) {
    t1 = shouldShowLocation ? <ProjectLocationText project={project} goTo={goTo} /> : getProjectAccessAndSize(project);
    $[0] = goTo;
    $[1] = project;
    $[2] = shouldShowLocation;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const secondaryText = t1;
  let t2;
  if ($[4] !== isScreenXs || $[5] !== project) {
    t2 = !shouldHideOpenProject(project) && !isScreenXs;
    $[4] = isScreenXs;
    $[5] = project;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const shouldShowOpenProjectButton = t2;
  const t3 = project.thumbnailUrl ?? defaultProjectThumbnail;
  let t4;
  if ($[7] !== project.name) {
    t4 = <var>{project.name}</var>;
    $[7] = project.name;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== project.name || $[10] !== t4) {
    t5 = <Tooltip title={t4} className={NO_TRANSLATE_CLASS}>{project.name}</Tooltip>;
    $[9] = project.name;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== project || $[13] !== sortBy) {
    t6 = <ProjectCardDate project={project} sortBy={sortBy} />;
    $[12] = project;
    $[13] = sortBy;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== contextType || $[16] !== project || $[17] !== shouldShowOpenProjectButton) {
    t7 = shouldShowOpenProjectButton ? <ProjectOpenButton project={project} contextType={contextType} /> : undefined;
    $[15] = contextType;
    $[16] = project;
    $[17] = shouldShowOpenProjectButton;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== href || $[20] !== isSelected || $[21] !== menuItems || $[22] !== onCardClick || $[23] !== project || $[24] !== secondaryText || $[25] !== t3 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== variant) {
    t8 = <ListItemCardMobile item={project} image={t3} imageFallbackSrc={defaultProjectThumbnail} imageAlt="Project thumbnail" title={t5} href={href} onCardClick={onCardClick} subtitle={t6} secondaryText={secondaryText} actions={t7} menuItems={menuItems} variant={variant} isSelected={isSelected} />;
    $[19] = href;
    $[20] = isSelected;
    $[21] = menuItems;
    $[22] = onCardClick;
    $[23] = project;
    $[24] = secondaryText;
    $[25] = t3;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = variant;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
}